import { BezierLineMarker } from '../bezier/bezierLineMarker'
import { MeasurementMarkerRenderer } from './measurementMarkerRenderer'
import { MeasurementMarkerController } from './measurementMarkerController'
import { MeasurementMarkerStateManager } from './measurementMarkerStateManager'

class MeasurementMarker extends BezierLineMarker {
  constructor() {
    super()
    this.controller = new MeasurementMarkerController(this)
    this.renderer = new MeasurementMarkerRenderer(this)
    this.state = new MeasurementMarkerStateManager(this)
  }

  public static typeName = 'MeasurementMarker'
}

export { MeasurementMarker }
